import { render, staticRenderFns } from "./OtherSalesCard.vue?vue&type=template&id=35b2e6bf&scoped=true"
import script from "./OtherSalesCard.vue?vue&type=script&lang=js"
export * from "./OtherSalesCard.vue?vue&type=script&lang=js"
import style0 from "./OtherSalesCard.vue?vue&type=style&index=0&id=35b2e6bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b2e6bf",
  null
  
)

export default component.exports